import Config from './config'
import Routes from './routes'

export default {
  Config,
  Routes,
}
